/**
 * Collection card capsules: list metafields often hold every filter option.
 * Rebuild .card-specs from the product title (… - CPU, RAM, Storage, …).
 */
(function () {
  // v2

  function parseTitleSpecs(title) {
    if (!title) return [];
    const dash = title.split(' - ');
    if (dash.length < 2) return [];
    const parts = dash.slice(1).join(' - ').split(',').map((p) => p.trim()).filter(Boolean);

    let cpu = '';
    let ram = '';
    let storage = '';
    let gpu = '';

    for (const p of parts) {
      const d = p.toLowerCase();
      if (
        !cpu &&
        (/intel|amd|ryzen|core ultra|core i|core [3579]/.test(d))
      ) {
        cpu = p;
      } else if (!ram && (d.includes('ddr') || (d.includes('gb') && d.includes('ram')))) {
        ram = p;
      } else if (!storage && /ssd|hdd|nvme/.test(d)) {
        storage = p;
      } else if (!gpu && /rtx|gtx|radeon|iris|graphics|\barc\b/.test(d)) {
        gpu = p;
      }
    }

    if (ram && !/ram/i.test(ram)) ram = ram + ' RAM';

    return [cpu, ram, storage, gpu].filter(Boolean);
  }

  function fixCard(card) {
    const titleEl = card.querySelector('.card__heading');
    const specsEl = card.querySelector('.card-specs');
    if (!titleEl || !specsEl) return;

    const title = (titleEl.textContent || '').replace(/\s+/g, ' ').trim();
    const items = parseTitleSpecs(title);
    if (!items.length) {
      // Fallback: keep only the first capsule of each “family” if title has no specs
      const existing = [...specsEl.querySelectorAll('.card-spec-item')].map((el) =>
        el.textContent.trim()
      );
      if (existing.length <= 4) return;
      const keep = existing.slice(0, 1);
      specsEl.innerHTML = keep
        .map((t) => `<span class="card-spec-item">${t}</span>`)
        .join('');
      return;
    }

    specsEl.setAttribute('data-specs-source', 'title-first');
    specsEl.innerHTML = items
      .map((t) => `<span class="card-spec-item"></span>`)
      .join('');
    [...specsEl.querySelectorAll('.card-spec-item')].forEach((el, i) => {
      el.textContent = items[i];
    });
  }

  function run(root) {
    (root || document)
      .querySelectorAll('.card-wrapper, .card, li.grid__item')
      .forEach(fixCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run());
  } else {
    run();
  }

  // Facet / pagination AJAX replaces the grid
  document.addEventListener('shopify:section:load', (e) => run(e.target));
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType === 1) run(n);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
